module.exports = __webpack_public_path__ + "img/refresh.3ae37888.png";